<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>
        <b-form @submit.prevent="reset()">
            <b-row class="d4d-login">
                
                <b-col cols="12" class="mt-1 title">Reset Password</b-col>
                <b-col cols="12 mt-4">
                    <ul class="mt-2 error-content">
                        <li class="error-text" v-for="error in tokenErrors">{{ error }}</li>
                    </ul>
                </b-col>
                <b-col cols="12 mt-4">
                    <label for="password">Password</label>
                    <input id="password" type="password" v-model="form.password" value="">
                    <span v-if="passwordError" class="form-error">This field is required</span>
                    <ul class="mt-2 error-content">
                        <li class="error-text" v-for="error in passwordErrors">{{ error }}</li>
                    </ul>
                </b-col>
                <b-col cols="12 mt-4">
                    <label for="confirm-password">Confirm Password</label>
                    <input id="confirm-password" type="password" v-model="form.confirmPassword" value="">
                    <span v-if="confirmPasswordError" class="form-error">{{ confirmPasswordError }}</span>
                </b-col>
                <b-col cols="12" class="mt-5">
                    <b-button block variant="primary" type="submit">Continue</b-button>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <div class="separator"></div>
                </b-col>
                <b-col cols="12" class="mt-1 mb-4 text-center">
                    <router-link :to="{ name: 'Login' }">
                        <span class="black-text"> Already have a D4D account?  </span>
                        <span class="green-text">Sign In</span>
                    </router-link>
                </b-col>
            </b-row>
        </b-form>
        <legal-message/>
        <b-modal id="modal-reset-password-success" no-close-on-backdrop centered hide-header hide-footer>
            <div class="children-privacy-protection">
                <div class="children-privacy-protection-header">
                </div>
                <div class="children-privacy-protection-body">
                    <div class="alert alert-success" role="alert">
                        Password reset successfully
                    </div>
                </div>
                <div class="children-privacy-protection-button">
                </div>
            </div>
        </b-modal>
    </b-container>
</template>

<script>
    import { UserService } from '../Services';
    import { Spinner } from '../../../core/Utils'
    import LegalMessage from "../Components/LegalMessage"

    export default {
        name: 'ResetPassword',
        components: { LegalMessage },
        data(){
            return {
                form: { token: "", email: "", password: "", confirmPassword: "" },
                passwordError: false,
                confirmPasswordError: "",
                passwordErrors: [],
                tokenErrors: [],
                serviceError: false
            }
        },
        methods: {
            reset(){
                const form = this.form;
                form.token = this.$route.query.token;
                form.email = this.$route.query.email;

                const password = form.password;
                const confirmPassword = form.confirmPassword;
                this.passwordError = password === "";

                if(confirmPassword === "")this.confirmPasswordError = "This field is required";
                if(password !== confirmPassword) this.confirmPasswordError =  "Must coincide with password";
                if(confirmPassword !== "" && password === confirmPassword) this.confirmPasswordError =  "";

                if(password && confirmPassword && password === confirmPassword) {
                    Spinner.start()
                    this.passwordErrors = []
                    this.tokenErrors = []
                    this.serviceError = false

                    UserService.changePassword(form).then(response => {
                        Spinner.stop();
                        
                        this.$bvModal.show('modal-reset-password-success');
                        setTimeout(() => {
                            this.$bvModal.hide('modal-reset-password-success');
                            this.$router.push({name: 'Login'});
                        }, 1500)
                    }).catch(err => {
                        Spinner.stop()
                        this.serviceError = 'Unexpected error, please try again.'
                        if (err) {
                            if (err.message) {
                                this.serviceError = err.message
                            }
                            if (err.errors && err.errors['Password']) {
                                err.errors['Password'].forEach(error => this.passwordErrors.push(error))
                            }

                            if (err.errors && err.errors['InvalidToken']) {
                                err.errors['InvalidToken'].forEach(error => this.tokenErrors.push(error))
                            }
                        }
                    })
                }
            }
        }
    }

</script>
<style scoped lang="stylus">

    @import "../Styles/security_styles.styl"

    .last-updated
        font-family arial, sans-serif
        font-size 12px
        font-weight bold
        font-style italic
        color black


    .children-privacy-protection-body
        .alert-success
            margin-top: 1rem;

</style>